export enum ScaleUnitEnum {
  Metric = 'metric',
  Imperial = 'imperial',
}
